module.exports = __webpack_public_path__ + "img/logo.20503a3d.png";